import React from 'react'
import { useTranslation } from 'react-i18next'

import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'

import { calculateSampleTotalScore } from '../../utils/cuppingUtils'
import { CuppingSession, CuppingSessionSample } from '../../types/cuppingSession'
import { toReadableTimestamp } from '../../utils/dateUtils'
import { getLogName } from '../../utils/logUtils'
import LinkCard from '../fields/linkCard'

interface CuppingLinkButtonProps {
  session: CuppingSession
  sample: CuppingSessionSample | undefined
}

const CuppingLinkButton = (props: CuppingLinkButtonProps): JSX.Element => {
  const { t } = useTranslation()

  return (
    <LinkCard url={`/cuppings/${props.session.id}/`}>
      <Stack>
        <Typography variant="body2">{props.session.name}</Typography>
        <Typography variant="body2" sx={{ display: 'inline' }}>
          <span>{`${getLogName(props.sample?.log_data || null, '', t('logview.batch'))}:`}</span>
          <span style={{ fontWeight: 'bold', paddingLeft: '4px' }}>
            {!!props.session.cupping_form_data.score_calculation
              ? calculateSampleTotalScore(props.session, props.sample?.id)
              : 'N/A'}
          </span>
        </Typography>
        <Typography variant="body2">{toReadableTimestamp(props.session.created)}</Typography>
      </Stack>
    </LinkCard>
  )
}

export default CuppingLinkButton
